import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import background from '../../../misc/images/backgrounds/background_08.jpg'
import { IContactResponse } from '../../../models/Contact'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import { Breadcrumbs } from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'
import { Contact } from '../../templates/Contact'

const ContactPage = () => {
  const i18n = useRecoilValue(translate).contact
  const breadcrumbs = [
    {
      link: routes.contact,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<IContactResponse>(URI.getContactUri(lang))

  return (
    <>
      <ImageSection id={'contact'} image={background} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data && <Contact data={data.data} />}
      </PageWrapper>
    </>
  )
}

export default ContactPage
